<template>
  <div class="modal-overlay" v-if="showOffnetModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close">&times;</button>
      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
        <h3>Welcome to Sports Hub</h3>
        <p class="error-msg">Sorry this service is only available to Vodacom customers</p>
      </div>
      <div class="modal-body">
        <button class="submit-btn" @click="close">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import modalMixin from '@/mixins/modalMixin'

export default {
  name: 'OffnetModal',
  mixins: [modalMixin],
  computed: {
    ...mapState(['showOffnetModal'])
  },
  methods: {
    ...mapMutations(['closeAllModals'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.error-msg {
  color: $brand-red;
  font-size: 14px;
  font-weight: 500;
  margin-top: $space-md;
}

.submit-btn {
  margin-top: $space-base;
}
</style>
